import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { ApiResponse } from '@magnetar/admin-api-interfaces'

export interface AuditLogStatistics {
  total: number
  by_action: Record<string, number>
  by_resource_type: Record<string, number>
  by_user: Array<{
    user_id: number
    count: number
    user_name?: string
  }>
}

interface UseAuditLogStatisticsParams {
  start_date?: string
  end_date?: string
}

export function useAuditLogStatistics(params: UseAuditLogStatisticsParams = {}) {
  const { token } = useAuth()
  const { start_date, end_date } = params

  const queryParams = new URLSearchParams()
  if (start_date) queryParams.append('start_date', start_date)
  if (end_date) queryParams.append('end_date', end_date)

  const queryString = queryParams.toString()
  const url = queryString ? `/api/audit-logs/statistics?${queryString}` : '/api/audit-logs/statistics'

  const { data, error, mutate } = useGet<ApiResponse<AuditLogStatistics>>(
    token ? url : null,
    undefined,
    token ?? '',
  )

  return {
    statistics: data?.data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
